const state = {
	tasks: [],
	stats: null,
	total: null,
	projects: [],
	urls: []
}

export default state
